// libs
import React, { FunctionComponent } from 'react'

// interfaces / constants
import { CLASS_PREFIX } from 'src/constants/'
import { MAP_DEFAULT_ZOOM } from 'src/constants/map'
import {
  DisplaySettings,
  IContentItemType,
  mapDisplayModeToConst,
  PostDisplayMode,
  Purpose
} from 'src/interfaces/posts'

// classes
import Icon from 'src/components/forms/icon/icon'

import StaticMap from './static_map'

// helpers
import { MarkerFragmentFragment } from '@lopo-tech/lopo-api'
import './map.scss'

type MapSettings = { show: boolean }

const _settings: DisplaySettings<MapSettings> = {
  admin: {
    basic_ingredient: { show: false }
  },
  banner: {
    basic_ingredient: { show: false }
  },
  compact: {
    basic_ingredient: { show: false }
  },
  detail: {
    basic_ingredient: { show: true },
    media_candidate: { show: true }
  },
  preview: {
    basic_ingredient: { show: false }
  }
}

export type IMapProps = {
  data: MarkerFragmentFragment;
  displayMode: PostDisplayMode;
  postType?: IContentItemType;
  postId: string;
  purpose: Purpose;
};

// we cannot access the SCSS variables here unfortunatly, so we need to duplicate the color values
const COLOR_PRIMARY = '1E9F21' // $color-primary
const COLOR_SECONDARY_6 = 'F99A00' // $color-secondary-6
const _classPrefix = `${CLASS_PREFIX}map-ingredient`

const mapPostTypeToMarkerColor = (postType?: IContentItemType) =>
  postType === 'event' ? COLOR_SECONDARY_6 : COLOR_PRIMARY

const MapIngredient: FunctionComponent<IMapProps> = ({
  postType,
  data,
  displayMode,
  purpose
}) => {
  const settings = _settings[displayMode][purpose]

  if (!settings?.show) {
    return null
  }

  const displayModeCls = `${_classPrefix}__${mapDisplayModeToConst[displayMode]}`

  return (
    <div className={displayModeCls}>
      <div className={displayModeCls + '__map-wrapper'}>
        <StaticMap
          position={data.coordinates}
          zoom={MAP_DEFAULT_ZOOM}
          markerColor={mapPostTypeToMarkerColor(postType)}
          address={data.addressString}
        />
      </div>
      <p className={displayModeCls + '__address'}>
        {data.addressString && (
          <>
            <Icon
              size={16}
              name="marker"
              className={displayModeCls + '__icon'}
            />
            {data.addressString}
          </>
        )}
      </p>
    </div>
  )
}

export default MapIngredient
